import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Col, Collapse, CollapsePanel, Radio, Row, Text } from '@app/components'
import React, { useContext, useEffect } from 'react'

import { ZellePayIcon } from '~public'
import { OGPLogo } from '~public/icons/OGPLogo'

import { ACHPullContent, WireTransferContent } from './panels-contents'
import { IntlTransfer } from './panels-contents/intl-transfer'
import { OGBC2C } from './panels-contents/ogb-c2c'
import { ZellePay } from './panels-contents/zelle-pay'

export const PaymentMethodCollapse: React.FC<any> = ({
  selectedPanel,
  setSelectedPanel,
  wireTransactionType,
  setWireTransactionType,
  //hifiTransactionType,
  //setHifiTransactionType,
  selectedMethod,
  setSelectedMethod,
  form,
  achForm,
}) => {
  const { usa, ogp, mtl, fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    fetchUserInfo()
  }, [])

  // setWireTransactionType('wire-instructions') if usa==true
  useEffect(() => {
    if (usa) {
      setWireTransactionType('wire-instructions')
    } else {
      setWireTransactionType('wire-instructions-intl')
    }
  }, [usa])

  const setACH = () => {
    setSelectedPanel('3')
    //setSelectedMethod({ name: '', description: '', fund: '' })
  }
  const setWire = () => {
    setSelectedPanel('1')
    //setSelectedMethod({ name: '', description: '', fund: '' })
  }
  // const setOGB = () => {
  //   setSelectedPanel('2')
  //   //setSelectedMethod({ name: '', description: '', fund: '' })
  // }
  const setC2C = () => {
    setSelectedPanel('4')
    //setSelectedMethod({ name: '', description: '', fund: '' })
  }
  return (
    <Collapse activeKey={[selectedPanel]} expandIcon={({ isActive }) => <Radio checked={isActive} />}>
      {!usa && (
        <CollapsePanel
          header={
            <Header title={'Local Transfer'} description="Use local transfer methods depending on your country" />
          }
          key="5"
          onClick={() => setSelectedPanel('5')}
          //extra={<OGPLogo style={{ height: 50, width: 75, marginLeft: 10 }} />}
        >
          <IntlTransfer form={achForm} selectedMethod={selectedMethod} setSelectedMethod={setSelectedMethod} />
        </CollapsePanel>
      )}
      {usa && (
        <>
          {/* <CollapsePanel
            header={
              <Header
                title={'Old Glory Pay ($5k limit per day)'}
                description="Use Old Glory Pay to withdraw money from your digital account to your Old Glory account"
              />
            }
            key="2"
            onClick={() => setOGB()}
            extra={<OGPLogo style={{ height: 50, width: 75, marginLeft: 10 }} />}
          >
            <OGBPay form={achForm} selectedMethod={selectedMethod} setSelectedMethod={setSelectedMethod} />
          </CollapsePanel> */}
          <CollapsePanel
            header={
              <Header
                title={'Old Glory Bank ($10k limit per transaction)'}
                description="Use Old Glory Bank to withdraw money from your digital account to your Old Glory account"
              />
            }
            key="4"
            onClick={() => setC2C()}
            extra={<OGPLogo style={{ height: 50, width: 75, marginLeft: 10 }} />}
          >
            <OGBC2C form={achForm} selectedMethod={selectedMethod} setSelectedMethod={setSelectedMethod} />
          </CollapsePanel>
          {(!ogp || mtl == 0) && (
            <>
              <CollapsePanel
                header={
                  <Header
                    title={'Zelle Pay'}
                    description="Use Zelle Pay to withdraw money from your digital account to your Zelle account"
                  />
                }
                key="6"
                onClick={() => setSelectedPanel('6')}
                extra={<ZellePayIcon style={{ height: 50, width: 50, marginLeft: 0 }} />}
              >
                <ZellePay form={achForm} selectedMethod={selectedMethod} setSelectedMethod={setSelectedMethod} />
              </CollapsePanel>
            </>
          )}
        </>
      )}
      {(!usa || !ogp || mtl == 0) && (
        <>
          <CollapsePanel
            header={
              <Header
                title={'ACH (US Banks, Wise.com, Revolut.com)'}
                description="Send to your external bank account using an ACH transfer"
              />
            }
            key="3"
            onClick={() => setACH()}
          >
            <ACHPullContent form={achForm} selectedMethod={selectedMethod} setSelectedMethod={setSelectedMethod} />
          </CollapsePanel>

          <CollapsePanel
            header={
              <Header
                title={'Wire transfer'}
                description="Use wire transfer to withdraw money from your digital account"
              />
            }
            key="1"
            onClick={() => setWire()}
          >
            <WireTransferContent
              wireTransactionType={wireTransactionType}
              setWireTransactionType={setWireTransactionType}
              form={form}
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
            />
          </CollapsePanel>
        </>
      )}
    </Collapse>
  )
}

const Header = ({ title, description }) => {
  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Text>{title}</Text>
      </Col>
      <Col span={24}>
        <Text disabled>{description}</Text>
      </Col>
    </Row>
  )
}
